<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';

    import SourceSet from './SourceSet.vue';

    export default {
        mixins: [mixin],
        components: { SourceSet },
        props: {
            item: Object
        }
    }
</script>

<template>
    <a :href="item.url" class="card is-flex">
        <div v-if="item.imageSets && item.imageSets.length" class="card-image is-clipped">
            <source-set :imageSets="item.imageSets" />
        </div>

        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column">
            <h4 v-show="item.name" class="title is-4">{{ item.name }}</h4>
            <div v-show="item.date" class="block"><p>{{ todDateStr(item.date) }}</p></div>
            <div v-show="item.tags && item.tags.length" class="tags">
                <span v-for="tag in item.tags" :key="tag.id" class="tag is-primary">{{ tag.name }}</span>
            </div>
            <div v-show="item.intro" class="block mt-auto" v-html="item.intro"></div>
        </div>
    </a>
</template>
